// extracted by mini-css-extract-plugin
export default {"sectionTitle":"kKTOBBRb","remove":"ok3xWndD","sectionTitleWrapper":"QsPrCCOg","requiredIndicator":"b6CPG89a","mainFormSectionContent":"N3Co_Wz8","border":"OAwdtV2x"};